"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Switch = _interopRequireDefault(require("../Switch/Switch"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuItemSwitch = function MenuItemSwitch(_ref) {
  var icon = _ref.icon,
      onClick = _ref.onClick,
      isActive = _ref.isActive,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "onClick", "isActive"]);

  return (0, _themeUi.jsx)(_Switch["default"], _extends({}, props, {
    isActive: isActive,
    switchPosition: "right",
    onClick: onClick,
    sx: {
      height: 5,
      px: 3,
      width: '100%',
      justifyContent: 'space-between',
      '&:first-child': {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      },
      '&:last-child': {
        borderBottomLeftRadius: 'inherit',
        borderBottomRightRadius: 'inherit'
      },
      '&:hover': {
        bg: 'neutral.0'
      }
    }
  }), icon && (0, _themeUi.jsx)(_Icon["default"], {
    sx: {
      mr: 3
    },
    icon: icon
  }), (0, _themeUi.jsx)(_Text["default"], null, props.children));
};

MenuItemSwitch.propTypes = {
  icon: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired,
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = MenuItemSwitch;
exports["default"] = _default;